import React from 'react';
import '../../styles/BoutiqueDetail.css';

import LivrePratRecto from '../../images/PRAT_Recto.jpg';
import LivrePratVerso from '../../images/PRAT_Verso.jpg';
import LivreLavouerRecto from '../../images/LavouerRecto.jpg';
import LivreLavouerVerso from '../../images/LavouerVerso.jpg';

import ImgAccueilBoutique from '../../components/ImgAccueilBoutique';
import Footer from '../../components/Footer';

const Nouveautes = () => {
    // const navigate= useNavigate()
    return (
        <div className='BtqDetail'>
            <ImgAccueilBoutique />
            <h1 className='BtqDetail H1BtqDetail'> </h1>
            <h1 className='BtqDetail H2espBtqDetail'> </h1>
            <h2 className='BtqDetail H2BtqDetail'> Nouveautés 2025</h2>
            <h1 className='BtqDetail H2espBtqDetail'> </h1>
            
           
            {/* <div className='BtqDetail ColonBtqDetail'>
                <h3 className='H4BtqDetail'>Miel ADN41</h3>
                <h3 className='H4BtqDetail'>Miel de fleurs de printemps. Pôt de 500grs</h3>
                <div className='Mag'>
                    <img className='ImagBtqDetail' src={MielFleurs} alt="Miel Fleur" />
                </div>
                <h3 className='H4BtqDetail'>Miel récolté au château de Rochambeau. Pôt de 250grs</h3>
                <div className='Mag'>
                    <img className='ImagBtqDetail' src={MielRoch} alt="Miel Fleur" />
                </div>
            </div> */}
            <div className='BtqDetail ColonBtqDetail'>
                <h1 className='BtqDetail H2espBtqDetail'> </h1>
                                    
                    <h3 className='H5BtqDetail'>Nouveaux Livres en boutique</h3>
                <div className='Mag'>    
                    <h3 className='H5BtqDetail'>Le premier de Patrice Rat</h3>
                    <img className='ImagBtqLH' src={LivrePratRecto} alt="Livre Prat" />
                    <img className='ImagBtqLH' src={LivrePratVerso} alt="Livre Prat" />
                    </div>
                <div className='Mag'>
                <h3 className='H5BtqDetail'>Le second de Jean Jacques Loisel et Daniel Schweitz</h3>
                    <img className='ImagBtqLM' src={LivreLavouerRecto} alt="Livre Lavouer JJ Loisel" />
                    <img className='ImagBtqLM' src={LivreLavouerVerso} alt="Livre Lavouer JJ Loisel" />
                </div>

                
            </div>
            
            <div className='Mag'>
                    <h1 className='BtqDetail H2espBtqDetail'>  </h1>
                    <h3 className='H5BtqDetail'>Nos autres livres restent disponibles venez les découvrir dans notre boutique</h3>
                    
                
                    
                </div>
            <h1 className='BtqDetail H2espBtqDetail'> </h1>
            <div className='Mag'>
            <Footer />
            </div>
        </div>
    );
};

export default Nouveautes;